import { Component, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-main-heading',
  templateUrl: './main-heading.component.html',
  styleUrls: ['./main-heading.component.css'],
  inputs: ['title', 'showDiv', 'customStyle']
})
export class MainHeadingComponent implements AfterViewInit {
  title: string = '';
  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    this.el.nativeElement.querySelector('.last-word').style.color = 'rgba(34, 101, 148, 1)'; // Add your styles here
  }
  headingText(): string {
    if (this.title) {
      const words = this.title?.split(' ');
      const lastWord = words?.pop(); // Remove and get the last word

      // Use span with a class for styling the last word
      const styledLastWord = `<span class="last-word">${lastWord}</span>`;
      const updatedTitle = `${words?.join(' ')} ${styledLastWord}`;

      // Now you can use 'updatedTitle' in your component
      // Join the words back and include the styled last word
      return `${updatedTitle}`;
    }
    return '';
  }
  showDiv: boolean = false;
  customStyle: string = "";
}
